import { Box, CircularProgress, Grid } from '@mui/material';
import React, { useState } from 'react';
import styles from '../../CommunityPage.module.scss';
import GridListItem from './GridListItem';

const GridMode = ({ users, onScroll, loading }) => (
  <Grid
    onScroll={onScroll}
    className={styles.gridContent}
    alignItems="stretch"
    container
    spacing={2}
    columns={{ xl: 15, md: 15, sm: 12, xs: 12 }}
  >
    {users && users.map((user) => <GridListItem user={user} />)}
  </Grid>
);

export default GridMode;
